export default [
  {
    path: '/categories',
    meta: {
      auth: true,
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '',
        name: 'categories',
        component: () => import('~/categories/pages/Index.vue'),
      },
    ],
  },
];
